import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    setComments, checkedState, unCheckedState, checkedAllState, unCheckedAllState, SingleApproveAsync, SingleRejectAsync
} from './TimeOffApprovalSlice';
import moment from 'moment';
import AttachmentModal from '../../attachment/AttachmentModal';
import '../../../common/css/timeLive.css'
import './TimeOffApproval.css'
import { ShowSwalWithConfirmationMessage } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { formatDateWithDateAndMonthName, formatHoursOff, determineCultureFormat, getValueFromResource } from '../../../common/timeLiveFunction';
import { parseISO, format } from "date-fns"

const TimeOffApprovalItem = (props: any) => {
    const { timeOffApprovalList, t, IsEdit, isShowTimeOffInDays } = props;
    const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState);
    const popupRef = useRef<any>(null);
    const approvedButtonRef = useRef<any>(null);
    const rejectedButtonRef = useRef<any>(null);
    const modelRef = useRef<any>(null);
    const [id, setId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (modalIsOpen) {
            if (modelRef.current) {
                modelRef.current.click();
            }
        }
    }, [modalIsOpen])

    const handleCommentsChange = (e: any, AccountEmployeeTimeOffRequestId: any) => {
        dispatch(setComments({ AccountEmployeeTimeOffRequestId: AccountEmployeeTimeOffRequestId, Comments: e.target.value }))

    };

    const handleButtonClick = (e: any, AccountEmployeeTimeOffRequestId: any) => {
        let id = e.currentTarget.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    // dispatch(updateIsLoading(true));
                    const founditem = timeOffApprovalList.find((item: any) => item.AccountEmployeeTimeOffRequestId === AccountEmployeeTimeOffRequestId);
                    if (founditem) {
                        if (id === "Approved") {
                            dispatch(SingleApproveAsync(founditem))
                                .unwrap()
                                .then((originalPromiseResult) => {
                                    originalPromiseResult.StatusCode === "201" ?
                                        ShowToast("Approved Successfully", 'Success', "success", "toast-top-right") :
                                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                                })
                                .catch((rejectedValueOrSerializedError) => {
                                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                                })
                        }
                        else if (id === "Rejected") {
                            dispatch(SingleRejectAsync(founditem))
                                .unwrap()
                                .then((originalPromiseResult) => {
                                    originalPromiseResult.StatusCode === "201" ?
                                        ShowToast("Rejected Successfully", 'Success', "success", "toast-top-right") :
                                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                                })
                                .catch((rejectedValueOrSerializedError) => {
                                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                                })
                        }
                    }
                }
            })
            .catch((error) => {
            });
    };

    const renderEmployeeNameWithSystemApproverType = (FullName: string, StartDate: any, EndDate: any, SystemApproverTypeId: any) => {
        let SystemApproverType: string = "";
        let SystemApproverTypeToolTip: string = "";

        if (SystemApproverTypeId == 1) {
            SystemApproverType = "(TL)";
            SystemApproverTypeToolTip = "Team Lead";
        }
        else if (SystemApproverTypeId == 2) {
            SystemApproverType = "(PM)";
            SystemApproverTypeToolTip = "Project Manager";
        }
        else if (SystemApproverTypeId == 3) {
            SystemApproverType = "(SE)";
            SystemApproverTypeToolTip = "Specific Employee";
        }
        else if (SystemApproverTypeId == 4) {
            SystemApproverType = "(EU)";
            SystemApproverTypeToolTip = "External User";
        }
        else if (SystemApproverTypeId == 5) {
            SystemApproverType = "(EM)";
            SystemApproverTypeToolTip = "Employee Manager";
        }
        return (
            <>
                <a className='text-dark fw-bold d-block mb-1'>
                    {FullName} {SystemApproverType}
                </a>
                <span style={{ color: '#7b8ba6', fontSize: 11 ,   display: 'inline-flex', alignItems: 'center' }} >
                    <i className="ki-outline ki-calendar text-gray fs-4 me-1 "></i>
                    {/* {moment.parseZone(StartDate).format('DD MMM yy')} - {moment.parseZone(EndDate).format('DD MMM yy')} */}
                    {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(EndDate, cultureInfoName.toString())}
                </span>
            </>
        );
    }

    const handleAttachment = (AccountEmployeeTimeOffRequestId: any) => {
        setId(AccountEmployeeTimeOffRequestId);
        setModalIsOpen(true);
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                        {IsEdit ? (
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={timeOffApprovalList.every((item: any) => item.isSelected === 0) ? false :
                                            (timeOffApprovalList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        ) : null}
                        <th className='col'>
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('Time Off Type')} */}
                            {getValueFromResource('Time Off Type', dispatch, t)}
                        </th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Total Days', dispatch, t) : getValueFromResource('Total Hours', dispatch, t)}</th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Hours Off', dispatch, t) : getValueFromResource('Days Off', dispatch, t)}</th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Available Days', dispatch, t) : getValueFromResource('Available Hours', dispatch, t)}</th>
                        {IsEdit ? (
                            <th className='w-250px'></th>
                        ) : null}
                        <th className='w-25px text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {timeOffApprovalList.length > 0 && timeOffApprovalList.map((timeOffApproval: any, i: any) => (
                        (timeOffApproval.isFiltered === 1 || timeOffApproval.isFiltered === -1) && (
                            <tr key={i}>
                                {IsEdit ? (
                                    <td>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                            <input
                                                type="checkbox"
                                                className="form-check-input widget-9-check "
                                                checked={timeOffApproval.isSelected == 0 ? false : true}
                                                onChange={(e) => { handleCheckboxChange(e, timeOffApproval.AccountEmployeeTimeOffRequestId) }}
                                            />
                                        </div>
                                    </td>
                                ) : null}
                                <td>
                                    {renderEmployeeNameWithSystemApproverType(timeOffApproval.FullName, timeOffApproval.StartDate, timeOffApproval.EndDate, timeOffApproval.SystemApproverTypeId)}
                                </td>
                                <td>
                                    <span className="d-block mb-1">
                                        {timeOffApproval.AccountTimeOffType}
                                    </span>
                                    {timeOffApproval.Description !== "" ? (
                                        <a
                                            style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7', cursor: 'pointer' }}
                                            className='text-dark fw-bold d-block'
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content={t(`${timeOffApproval.Description}`)}
                                            data-tooltip-place="bottom"
                                        >
                                            {/* {t('View Description')} */}
                                            {getValueFromResource('View Description', dispatch, t)}
                                        </a>
                                    ) : null}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.DayOff != "" && parseFloat(timeOffApproval.DayOff) > 0) ? parseFloat(timeOffApproval.DayOff) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.DayOff), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')}  */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block' >
                                                {/* {(timeOffApproval.HoursOff !== "" && parseFloat(timeOffApproval.HoursOff) > 0) ? parseFloat(timeOffApproval.HoursOff) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.HoursOff), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}  */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.HoursOff != "" && parseFloat(timeOffApproval.HoursOff) > 0) ? parseFloat(timeOffApproval.HoursOff) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.HoursOff), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}   */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.DayOff != "" && parseFloat(timeOffApproval.DayOff) > 0) ? parseFloat(timeOffApproval.DayOff) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.DayOff), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')} */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.AvailableDay != "" && parseFloat(timeOffApproval.AvailableDay) > 0) ? parseFloat(timeOffApproval.AvailableDay) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.AvailableDay), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')}   */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.Available != "" && parseFloat(timeOffApproval.Available) > 0) ? parseFloat(timeOffApproval.Available) : 0} */}
                                                {`${formatHoursOff(Number(timeOffApproval.Available), 2, cultureInfoName.toString())}`}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}   */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                                {IsEdit ? (
                                    <td className='p-0 m-0'>
                                        <button
                                            id="Approved"
                                            ref={approvedButtonRef}
                                            className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark  me-1`}
                                            onClick={(e: any) => handleButtonClick(e, timeOffApproval.AccountEmployeeTimeOffRequestId)}
                                        >
                                            <i className="bi bi-check iconApprove p-0"></i>
                                            <span style={{ color: '#009688' }}>
                                                {/* {t('Approved')} */}
                                                {getValueFromResource('Approve', dispatch, t)}
                                            </span>
                                        </button>
                                        <button
                                            id="Rejected"
                                            ref={rejectedButtonRef}
                                            className={`btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark`}
                                            onClick={(e: any) => handleButtonClick(e, timeOffApproval.AccountEmployeeTimeOffRequestId)}
                                        >
                                            <i className="bi bi-x iconReject p-0"></i>
                                            <span style={{ color: '#E53935' }}>
                                                {/* {t('Rejected')} */}
                                                {getValueFromResource('Reject', dispatch, t)}
                                            </span>
                                        </button>
                                    </td>
                                ) : null}
                                <td>
                                    <div className="btn-group" style={{ float: 'right' }}>
                                        <a
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Comments")}
                                            {getValueFromResource('Comments', dispatch, t)}
                                            data-tooltip-place="top">
                                            <i className="bi bi-card-text fs-3 iconColor"></i>
                                        </a>
                                        <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-4 py-4 fs-2 w-300px" role="menu">
                                            <div className='menu-item text-gray-800'>
                                                <div className="dropdown-menu-item">
                                                    <textarea
                                                        placeholder=
                                                        // {t("Your comments here...")}
                                                        {getValueFromResource('Your comments here...', dispatch, t)}
                                                        className="form-control fs-7 fw-normal"
                                                        rows={4}
                                                        style={{ borderRadius: 2 }}
                                                        onChange={(e) => handleCommentsChange(e, timeOffApproval.AccountEmployeeTimeOffRequestId)}
                                                        value={timeOffApproval.Comments}
                                                    />
                                                </div>
                                            </div>
                                        </ul>
                                        <a
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Attachment")}
                                            {getValueFromResource('Attachment', dispatch, t)}
                                            data-tooltip-place="top"
                                            onClick={() => handleAttachment(timeOffApproval.AccountEmployeeTimeOffRequestId)}
                                        >
                                            <i className="bi bi-paperclip fs-3 iconColor"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        )
                    ))}
                </tbody>
            </table>
            {timeOffApprovalList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found', dispatch, t)}
                    </p>
                </div>
            }
            {
                modalIsOpen && (
                    <>
                        <AttachmentModal
                            isOpen={modalIsOpen}
                            closeModal={() => setModalIsOpen(false)}
                            Id={id}
                            IsUploadRequired={false}
                            AccountAttachmentTypeId={3}
                        />

                    </>
                )
            }
        </>
    )
}

export default TimeOffApprovalItem